<template>
  <div class="login">
    <form
      action
      class="form"
      @submit.prevent="login"
    >
      <v-img
        src="@/assets/images/logoPlexigridYellow.png"
        max-height="100"
        max-width="100"
        class="centerPlexi"
      />
        <label
          class="form-label"
          for="#email"
        >Email</label>
        <input
          id="email"
          v-model="email"
          class="form-input"
          type="text"
          required
          :placeholder="email"
        >
        <label
          class="form-label"
          for="#password"
        >Password</label>
        <input
          id="password"
          v-model="password"
          class="form-input"
          type="password"
          :placeholder='password'
        >
        <p
          v-if="error"
          class="error"
        >
          An error has occurred
        </p>
        <v-btn
          class="form-submit"
          type="submit"
        >
          Login
        </v-btn>
    </form>
  </div>
</template>

<script>
import { login } from '@/services/auth/auth'
// import { parseJwt } from '@/assets/queries'

export default {
  name: 'LoginView',

  metaInfo: {
    title: 'Login'
  },

  data: () => ({
    email: '',
    password: '',
    error: false,
    token: ''
  }),

  mounted () {
    sessionStorage.clear()
    this.$store.dispatch('resetState')
  },

  methods: {
    async login () {
      try {
        const result = await login(this.email, this.password)
        sessionStorage.access = result.access
        sessionStorage.refresh = result.refresh
        // sessionStorage.user_id = parseJwt(result.access).user_id

        // sessionStorage.access = 'jasjdfsaodfjaos'
        // sessionStorage.refresh = 'adkljfasdkadsfasf'
        // sessionStorage.user_id = 1

        sessionStorage.setItem('logged', true)
        this.$store.dispatch('setElement', { path: 'logged', value: true })

        // this.$sessionStorage.theme = 'dark'
        this.$router.push('/plants')
      } catch (error) {
        console.log(error)
        this.error = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.login {
  padding: 2rem;
}
.title {
  text-align: center;
  font-size: 24px;
  color: #f4c020;
}
.form {
  margin: 3rem auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 20%;
  min-width: 350px;
  max-width: 100%;
  background: #1e1e1e;
  border-radius: 5px;
  padding: 40px;
  box-shadow: 0 4px 10px 4px rgba(0, 0, 0, 0.3);
}
.form-label {
  align-self: flex-start;
  margin-top: 2rem;
  color: white;
  margin-bottom: 0.5rem;
  &:first-of-type {
    margin-top: 0rem;
  }
}
.form-input {
  padding: 10px 15px;
  background: none;
  background-image: none;
  border: 1px solid white;
  color: white;
  &:focus {
    outline: 0;
    border-color: #f4c020;
  }
}
.form-submit {
  background: #272727 !important;
  border: none;
  color: #f4c020 !important;
  margin-top: 3rem;
  padding: 1rem 0;
  cursor: pointer;
  text-align: center;
  transition: background 0.2s;
  border-radius: 3px;
  &:hover {
    background: #f4c020 !important;
    color: #000 !important;
  }
}
.error {
  margin: 1rem 0 0;
  color: #ff4a96;
}
.msg {
  margin-top: 3rem;
  text-align: center;
}
.centerPlexi{
  margin-left: 34%;
  margin-bottom: 15px;
}
</style>
